// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v9-compat and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBIsp2qYsI0w4GD0yX3KZLEzuXotAaLWD4",
  authDomain: "between-the-walls.firebaseapp.com",
  projectId: "between-the-walls",
  storageBucket: "between-the-walls.firebasestorage.app",
  messagingSenderId: "601191417401",
  appId: "1:601191417401:web:82d80fd83d7e145c4e2fe8",
  measurementId: "G-0KXF4BCGKW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export default app;